export default __webpack_public_path__ + "db85f95651d1c4b9d7c6f50e85f44c2f.png";